/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const pitchDeckListItemSchema = z.object({
  id: z.optional(z.string()),
  startupName: z.optional(z.string()),
  status: z.optional(z.string()),
  createdAt: z.optional(z.iso.datetime()),
  failureReason: z.string().nullish(),
});
